export const BASE_URL = "https://api.agro.gov.kg/dictionary-service-ws";

export const TEST_URL = "https://api.agrosmart.gov.kg/dictionary-service-ws";

export const IDENTITY_BASE_URL =
  "https://api.agro.gov.kg/agrosmart-identity-ws"; // PROD
export const IDENTITY_TEST_URL =
  "https://api.agrosmart.gov.kg/agrosmart-identity-ws"; // TEST

export const BASE_KEY_CLOCK =
  "https://api.agrosmart.gov.kg/agrosmart-identity-ws";
